import { isString } from 'lodash';
import { RowContent } from '@shared/components/RowContent';
import { ButtonView } from '@shared/components/View';
import { useButtonBarContext } from './ButtonBarContext';
import { ButtonProps } from './ButtonProps';
import { useOnClickAsync } from './useOnClickAsync';
import styles from './Button.module.css';

export function Button({
  variant = 'tertiary',
  size = 'large',
  icon,
  iconSize,
  iconOnly,
  label,
  numberOfLines,
  inactive,
  children,
  startContent,
  endContent,
  arrow,
  danger,
  engaged,
  className,
  style,
  disabled,
  loading: loadingProp,
  onClick: onClickProp,
  attributionId,
  underline,
  ...props
}: ButtonProps) {
  const [loading, onClick] = useOnClickAsync({
    onClick: onClickProp,
    loading: loadingProp,
    attributionId,
  });
  const buttonbar = useButtonBarContext();

  return (
    <ButtonView
      className={[styles.button, className]}
      style={style}
      disabled={disabled || loading || undefined}
      data-variant={buttonbar ? buttonbar.variant : variant}
      data-size={buttonbar ? buttonbar.size : size}
      data-buttonbar={buttonbar ? true : undefined}
      data-loading={loading || undefined}
      data-danger={danger || undefined}
      data-engaged={engaged || undefined}
      data-inactive={inactive || undefined}
      data-icon-only={iconOnly || undefined}
      data-arrow={arrow || undefined}
      data-underline={underline || undefined}
      aria-label={isString(label) ? label : undefined}
      onClick={onClick}
      vars={{ 'icon-size': iconSize }}
      {...props}
    >
      <RowContent
        icon={icon}
        iconSize={iconSize}
        label={iconOnly ? undefined : label}
        numberOfLines={numberOfLines}
        startContent={startContent}
        endContent={endContent}
      >
        {children}
      </RowContent>
    </ButtonView>
  );
}
